<template>
  <Modal :value="open" :onClose="close" :close="false">
    <h4 class="title mb-6">{{ valueProduto.descricao }}</h4>

    <b-tabs v-model="abaAtiva">
      <br />
      <b-tab title="Produto" active>
        <b-row>
          <b-col md="3">
            <b-form-group label="Quantidade">
              <money
                class="form-control"
                v-model="valueProduto.quantidade"
                :disabled="valueProduto.lote"
                v-bind="quantityOptions"
              />
            </b-form-group>
            <b-form-group
              label="QTD convertida"
              v-if="valueProduto.quantidade != valueProduto.quantity"
            >
              <input
                class="form-control"
                :value="valueProduto.quantity"
                disabled
              />
            </b-form-group>
          </b-col>

          <b-col md="3">
            <b-form-group label="Valor Unitário">
              <money
                class="form-control"
                v-model="valueProduto.preco"
                v-bind="priceOptions"
              />
            </b-form-group>
          </b-col>

          <b-col md="3">
            <b-form-group label="Desconto">
              <money
                class="form-control"
                v-model="valueProduto.desconto"
                v-bind="configMask"
              />
            </b-form-group>
          </b-col>

          <b-col md="3">
            <b-form-group label="Total de Item R$">
              <money
                class="form-control"
                disabled
                v-model="valueProduto.total"
                v-bind="priceOptions"
              />
            </b-form-group>
          </b-col>
          <b-col md="3">
            <b-form-group id="origem" label="Origem" label-for="origem">
              <b-form-select v-model="valueProduto.id_origem" placeholder="">
                <b-form-select-option
                  v-for="origem in origens"
                  :key="origem.id + 'origem'"
                  :value="origem.id"
                >
                  {{ origem.descricao }}
                </b-form-select-option>
              </b-form-select>
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group label="CST">
              <VueSelect
                placeholder="Código CST"
                label="codigo"
                @input="setCSTCSOSN"
                v-model="valueProduto.cst_csosn"
                :options="cstcsosns"
              >
                <template slot="option" slot-scope="option">
                  <div>{{ option.codigo }} - {{ option.descricao }}</div>
                </template>
              </VueSelect>
            </b-form-group>
          </b-col>

          <b-col md="4">
            <b-form-group label="CFOP">
              <VueSelect
                placeholder="Código CFOP"
                label="codigo"
                v-model="valueProduto.cfop_compra"
                :options="cfops"
                @input="setCFOP"
                @search="onSearchCFOP"
              >
                <template slot="option" slot-scope="option">
                  <div>{{ option.codigo }} - {{ option.descricao }}</div>
                </template>
              </VueSelect>
            </b-form-group>
          </b-col>
        </b-row>
      </b-tab>

      <!-- ICMS ST -->
      <b-tab title="ICMS ST">
        <br />
        <b-row>
          <b-col md="4">
            <b-form-group label="% ICMS ST">
              <money
                class="form-control"
                v-model="valueProduto.pICMSSTpICMSST"
                v-bind="priceOptions"
              />
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group label="Base ST">
              <money
                class="form-control"
                v-model="valueProduto.VBCST"
                v-bind="priceOptions"
              />
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group label="Valor ICMS ST">
              <money
                class="form-control"
                v-model="valueProduto.VICMSST"
                v-bind="priceOptions"
              />
            </b-form-group>
          </b-col>
        </b-row>
      </b-tab>

      <!-- ICMS/IPI -->
      <b-tab title="ICMS/IPI">
        <br />
        <b-row>
          <b-col md="4">
            <b-form-group label="% ICMS">
              <money
                class="form-control"
                v-model="valueProduto.pICMS"
                v-bind="priceOptions"
              />
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group label="Valor ICMS">
              <money
                class="form-control"
                v-model="valueProduto.vICMS"
                v-bind="priceOptions"
              />
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group label="Base ICMS">
              <money
                class="form-control"
                v-model="valueProduto.vBCICMS"
                v-bind="priceOptions"
              />
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group label="% IPI">
              <money
                class="form-control"
                v-model="valueProduto.pIPI"
                v-bind="priceOptions"
              />
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group label="Base IPI">
              <money
                class="form-control"
                v-model="valueProduto.vBCIpi"
                v-bind="priceOptions"
              />
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group label="Valor IPI">
              <money
                class="form-control"
                v-model="valueProduto.vIPI"
                v-bind="priceOptions"
              />
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group label="CST IPI">
              <VueSelect
                placeholder="Digite o código para pesquisar"
                label="codigo"
                @input="setCSTIPI"
                v-model="valueProduto.cstipi"
                :options="cstipis"
                @search="onSearchCSTIPI"
                :clearable="true"
              >
                <template slot="no-options">
                  Informe o código do CST IPI
                </template>
                <template slot="option" slot-scope="option">
                  <div class="d-center">
                    {{ option.codigo + " - " + option.descricao }}
                  </div>
                </template>
                <template slot="selected-option" slot-scope="option">
                  <div class="selected d-center">
                    {{ option.codigo + " - " + option.descricao }}
                  </div>
                </template>
              </VueSelect>
            </b-form-group>
          </b-col>
        </b-row>
      </b-tab>

      <!-- PIS/COFINS -->
      <b-tab title="PIS/COFINS">
        <br />
        <b-row>
          <b-col md="4">
            <b-form-group label="% PIS">
              <money
                class="form-control"
                v-model="valueProduto.pPIS"
                v-bind="priceOptions"
              />
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group label="Valor PIS">
              <money
                class="form-control"
                v-model="valueProduto.vPIS"
                v-bind="priceOptions"
              />
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group label="Base PIS">
              <money
                class="form-control"
                v-model="valueProduto.vBCPis"
                v-bind="priceOptions"
              />
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group label="CST PIS">
              <VueSelect
                placeholder="Código CST PIS"
                label="codigo"
                v-model="valueProduto.cstpis"
                :options="cstspis"
              >
                <template slot="option" slot-scope="option">
                  <div>{{ option.codigo }} - {{ option.descricao }}</div>
                </template>
              </VueSelect>
            </b-form-group>
          </b-col>

          <b-col md="4">
            <b-form-group label="% COFINS">
              <money
                class="form-control"
                v-model="valueProduto.pCOFINS"
                v-bind="priceOptions"
              />
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group label="Valor COFINS">
              <money
                class="form-control"
                v-model="valueProduto.vCOFINS"
                v-bind="priceOptions"
              />
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group label="Base COFINS">
              <money
                class="form-control"
                v-model="valueProduto.vBCConfis"
                v-bind="priceOptions"
              />
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group label="CST COFINS">
              <VueSelect
                placeholder="Código CST COFINS"
                label="codigo"
                v-model="valueProduto.cstcofins"
                :options="cstscofins"
              >
                <template slot="option" slot-scope="option">
                  <div>{{ option.codigo }} - {{ option.descricao }}</div>
                </template>
              </VueSelect>
            </b-form-group>
          </b-col>
        </b-row>
      </b-tab>
    </b-tabs>

    <div class="confirm-buttons mt-4 d-flex justify-content-end">
      <Button type="error" @click="close()">Fechar</Button>
      <Button
        type="success"
        class="ml-2"
        @click="
          () => {
            save();
            close();
          }
        "
        >Gravar</Button
      >
    </div>
  </Modal>
</template>

<script>
import { Modal } from "@/components";
import { Button } from "@/components/Form";
import { Money } from "v-money";
import { debounce } from "lodash";
import VueSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import {
  MONEY as settingMoney,
  priceOptions,
  quantityOptions,
} from "@/modules/Application";
import { SistemaMixin } from "@/modules/Application";
import FormatMixin from "@/modules/Application/mixins/FormatMixin";
import PessoaMixin from "@/modules/Application/mixins/PessoaMixin";
import _ from "lodash";

export default {
  name: "ModalProduto",
  mixins: [FormatMixin, PessoaMixin, SistemaMixin],
  components: {
    Modal,
    Button,
    Money,
    VueSelect,
  },
  props: {
    open: Boolean,
    close: Function,
    changeProduto: Function,
    produto: Object,
  },
  data() {
    return {
      abaAtiva: 0,
      cstcsosn: null,
      cfop: null,
      ncm: null,
      cstcsosns: [
        {
          codigo: "00",
          descricao: "Tributada Integralmente",
        },
        {
          codigo: "10",
          descricao:
            "Tributada e com cobrança do ICMS por substituição tributária",
        },
        {
          codigo: "20",
          descricao: "Com redução de base de cálculo",
        },
        {
          codigo: "30",
          descricao:
            "Isenta ou não tributada e com cobrança do ICMS por substituição tributária",
        },
        {
          codigo: "40",
          descricao: "Isenta",
        },
        {
          codigo: "41",
          descricao: "Não tributada",
        },
        {
          codigo: "50",
          descricao: "Suspensão",
        },
        {
          codigo: "51",
          descricao: "Diferimento",
        },
        {
          codigo: "60",
          descricao: "ICMS cobrado anteriormente por substituição tributária",
        },
        {
          codigo: "70",
          descricao:
            "Com redução de base de cálculo e cobrança do ICMS por substituição tributária",
        },
        {
          codigo: "90",
          descricao: "Outras",
        },
      ],
      origens: [
        {
          id: 0,
          descricao: "0 - Nacional, exceto as indicadas nos códigos 3 a 5",
        },
        {
          id: 1,
          descricao:
            "1 - Estrangeira - Importação direta, exceto a indicada no código 6",
        },
        {
          id: 2,
          descricao:
            "2 - Estrangeira - Adquirida no mercado interno, exceto a indicada no código 7",
        },
        {
          id: 3,
          descricao:
            "3 - Nacional, mercadoria ou bem com Conteúdo de Importação superior a 40%",
        },
        {
          id: 4,
          descricao:
            "4 - Nacional, cuja produção tenha sido feita em conformidade com os processos produtivos básicos de que tratam o Decreto-Lei nº 288/1967.",
        },
        {
          id: 5,
          descricao:
            "5 - Nacional, mercadoria ou bem com Conteúdo de Importação inferior ou igual a 40%",
        },
        {
          id: 6,
          descricao:
            "6 - Estrangeira - Importação direta, sem similar nacional, constante em lista de Resolução Camex e gás natural",
        },
        {
          id: 7,
          descricao:
            "7 - Estrangeira - Adquirida no mercado interno, sem similar nacional, constante em lista de Resolução Camex e gás natural",
        },
        {
          id: 8,
          descricao:
            "8 – Nacional: mercadoria ou bem com Conteúdo de Importação superior a 70%;",
        },
      ],
      cfops: [],
      ncms: [],
      valueProduto: {},
      configMask: settingMoney,
      priceOptions,
      quantityOptions,
      cstipis: [],
      cstspis: [],
      cstscofins: [],
    };
  },
  mounted() {
    this.valueProduto = this.produto;
    this.cstcsosn = this.valueProduto.cstcsosn;
    this.ncm = this.valueProduto.ncm;
    this.cfop = this.valueProduto.cfop_compra;
    this.getCSTIPIByCodigo().then((data) => (this.cstipis = data));
    this.getCSTPISByCodigo().then((data) => (this.cstspis = data));
    this.getCSTCofinsByCodigo().then((data) => (this.cstscofins = data));
  },
  watch: {
    "valueProduto.quantidade"(novaQuantidade) {
      const conversor =
        parseFloat(this.valueProduto.unidade_medida?.conversor) || 1;
      this.valueProduto.quantity =
        (parseFloat(novaQuantidade) || 0) * conversor;
      this.atualizarTotal();
    },
    "valueProduto.preco": "atualizarTotal",
    "valueProduto.desconto": "atualizarTotal",
  },
  methods: {
    atualizarQuantidadeConvertida() {
      // Pega o valor da unidade de compra, não do convertido!
      const quantidade = parseFloat(this.valueProduto.quantidade) || 0;
      const conversor =
        parseFloat(this.valueProduto.unidade_medida?.conversor) || 1;
      this.valueProduto.quantity = quantidade * conversor;
    },
    atualizarTotal() {
      const preco = parseFloat(this.valueProduto.preco) || 0;
      const quantidade = parseFloat(this.valueProduto.quantidade) || 0;
      const desconto = parseFloat(this.valueProduto.desconto) || 0;
      this.valueProduto.total = preco * quantidade - desconto;
    },
    setCSTIPI(cstipi) {
      this.valueProduto.cstipi = cstipi;
    },
    onSearchCSTIPI(search, loading) {
      if (search.length) {
        loading(true);
        this.searchCSTIPI(loading, search, this);
      }
    },
    searchCSTIPI: _.debounce(async (loading, search, vm) => {
      vm.cstipis = await vm.getCSTIPIByCodigo(search);
      loading(false);
    }, 350),
    save() {
      this.valueProduto.produto_editado = true;
      this.valueProduto.ncm = this.ncm;
      this.valueProduto = {
        ...this.valueProduto,
      };
      this.changeProduto(this.valueProduto);
      this.$toast.success("Produto editado com sucesso!");
    },
    setCSTCSOSN(val) {
      this.valueProduto.cst_csosn = val;
    },
    setCFOP(val) {
      this.valueProduto.cfop_compra = val;
    },
    setNCM(val) {
      this.ncm = val;
    },
    onSearchCFOP(search, loading) {
      if (search.length) {
        loading(true);
        this.searchCFOP(loading, search, this);
      }
    },
    searchCFOP: debounce(async (loading, search, vm) => {
      vm.cfops = await vm.getCFOPByCodigo(search);
      loading(false);
    }, 300),
    onSearchNCM(search, loading) {
      if (search.length) {
        loading(true);
        this.searchNCM(loading, search, this);
      }
    },
    searchNCM: debounce(async (loading, search, vm) => {
      vm.ncms = await vm.getNCM(search);
      loading(false);
    }, 300),
  },
};
</script>

<style scoped>
.confirm-buttons {
  gap: 0.5rem;
}
</style>
